import React from 'react';
import PropTypes from 'prop-types';

import { FormGroup, Label, Input } from 'reactstrap';

export default function PrettyCheckbox(props) {
	const {
		strTitle,
		checked,
		value,
		bsSize,
		id,
		isDisabled,
		isReadOnly,
		iconSuccess,
		iconDanger,
		iconOn,
		iconOff,
		triState,
		reverse,
		simpleSelection,
		prettyRadio,
		labelDefault,
		labelSuccess,
		labelDanger,
	} = props;

	const renderSimpleSelection = (
		<div className="pretty p-icon p-jelly" alt={strTitle} title={strTitle}>
			<Input
				checked={checked}
				id={id}
				name={id}
				bsSize={bsSize}
				type="checkbox"
				onChange={props.onChange}
				disabled={isDisabled || isReadOnly || triState}
			/>
			<div className="state">
				<i className={`icon ${iconSuccess}`} />
				<label>{labelDefault || labelSuccess || labelDanger}</label>
			</div>
		</div>
	);

	const renderPrettyRadio = (
		<div>
			<div className="pretty p-icon p-toggle p-plain">
				<Input
					value={value}
					checked={checked}
					id={id}
					name={id}
					bsSize={bsSize}
					type="radio"
					onChange={props.onChange}
					disabled={isDisabled || isReadOnly || triState}
				/>
				<div className="state p-on">
					<i className={`icon ${iconOn}`} />
					<label>{labelDefault}</label>
				</div>
				<div className="state p-off">
					<i className={`icon ${iconOff}`} />
					<label>{labelDefault}</label>
				</div>
			</div>
		</div>
	);

	const renderDefault = (
		<div className="pretty p-icon p-toggle p-plain" alt={strTitle} title={strTitle}>
			<Input
				checked={checked}
				id={id}
				name={id}
				bsSize={bsSize}
				type="checkbox"
				onChange={props.onChange}
				disabled={isDisabled || isReadOnly || triState}
			/>
			<div className={`state ${isReadOnly ? '' : 'p-success-o'} ${reverse ? 'p-off' : 'p-on'}`}>
				<i className={`icon ${iconSuccess}`} />
				<label>{reverse ? labelDanger : labelSuccess}</label>
			</div>
			<div className={`state ${triState ? '' : isReadOnly ? '' : 'p-danger-o'} ${reverse ? 'p-on' : 'p-off'}`}>
				<i className={`icon ${triState ? 'fas fa-minus' : iconDanger}`} />
				<label>{reverse ? labelSuccess : labelDanger}</label>
			</div>
			<i className="for-transition" style={{ display: 'none' }} />
		</div>
	);

	return (
		<FormGroup check className="form-pretty-check">
			<Label check>
				{simpleSelection ? renderSimpleSelection : prettyRadio ? renderPrettyRadio : renderDefault}
			</Label>
		</FormGroup>
	);
}

PrettyCheckbox.propTypes = {
	bsSize: PropTypes.string,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	iconDanger: PropTypes.string,
	iconOff: PropTypes.string,
	iconOn: PropTypes.string,
	iconSuccess: PropTypes.string,
	id: PropTypes.string.isRequired,
	isDisabled: PropTypes.bool,
	isReadOnly: PropTypes.bool,
	label: PropTypes.string,
	help: PropTypes.string,
	labelDanger: PropTypes.string,
	labelDefault: PropTypes.string,
	labelSuccess: PropTypes.string,
	prettyRadio: PropTypes.bool,
	reverse: PropTypes.bool,
	simpleSelection: PropTypes.bool,
	strTitle: PropTypes.string,
	triState: PropTypes.bool,
	prettyRadioValue: PropTypes.string,
	values: PropTypes.object,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
};
